export const getActionFromSubtype = (subtype: string) => {
  if (subtype.includes('CREATE')) {
    return 'created';
  } else if (subtype.includes('UPDATE_POST_INVITE')) {
    return 'invited';
  } else if (subtype.includes('UPDATE')) {
    return 'updated';
  } else if (subtype.includes('IMPORT')) {
    return 'imported';
  } else if (subtype.includes('DELETE')) {
    return 'deleted';
  } else if (subtype.includes('UNARCHIVE')) {
    return 'unarchived';
  } else if (subtype.includes('ARCHIVE')) {
    return 'archived';
  } else if (subtype.includes('UNLOCK')) {
    return 'unlocked';
  } else if (subtype.includes('LOCK')) {
    return 'locked';
  } else if (subtype.includes('JOIN')) {
    return 'joined';
  }
  return 'action';
};
